module.exports = __webpack_public_path__ + "img/vip_card.e2a1927c.png";